import { mockData } from '@web/lib/demo/data/users';
import { diffComparisonValueFormat } from '@workalizer/shared/types';
import { getPercentageDiff } from '@workalizer/shared/utils';
export var individualCommTime = function (input) {
    var teamMembersCount = Math.floor(Math.random() * 5) + 3;
    var selectedUsers = mockData
        .filter(function (user) { return user.id !== input.userId; })
        .sort(function () { return Math.random() - 0.5; })
        .slice(0, teamMembersCount);
    var teamMembers = selectedUsers.map(function (user) {
        var meetCount = Math.floor(Math.random() * 5) + 1;
        var chatCount = Math.floor(Math.random() * 15) + 1;
        var prevMeetCount = Math.floor(Math.random() * 5) + 1;
        var prevChatCount = Math.floor(Math.random() * 15) + 1;
        return {
            userId: user.id,
            userName: user.name || user.email,
            meet: meetCount,
            chat: chatCount,
            prevMeet: prevMeetCount,
            prevChat: prevChatCount
        };
    });
    var chatDurationSecondsPerMessage = 180;
    var avgMeetingDurationSeconds = 1800;
    var currentMeet = teamMembers.reduce(function (sum, m) { return sum + m.meet * avgMeetingDurationSeconds; }, 0);
    var currentChat = teamMembers.reduce(function (sum, m) { return sum + m.chat * chatDurationSecondsPerMessage; }, 0);
    var previousMeet = teamMembers.reduce(function (sum, m) { return sum + m.prevMeet * avgMeetingDurationSeconds; }, 0);
    var previousChat = teamMembers.reduce(function (sum, m) { return sum + m.prevChat * chatDurationSecondsPerMessage; }, 0);
    return {
        teamMembers: teamMembers,
        totals: {
            meet: {
                current: currentMeet,
                previous: getPercentageDiff(previousMeet, currentMeet, {
                    comparisonValueFormat: diffComparisonValueFormat.durationSeconds
                })
            },
            chat: {
                current: currentChat,
                previous: getPercentageDiff(previousChat, currentChat, {
                    comparisonValueFormat: diffComparisonValueFormat.durationSeconds
                })
            }
        }
    };
};
